import { render } from "./CustomerDashboardContentLoader.vue?vue&type=template&id=25dc3b90&scoped=true&ts=true"
import script from "./CustomerDashboardContentLoader.vue?vue&type=script&lang=ts"
export * from "./CustomerDashboardContentLoader.vue?vue&type=script&lang=ts"

import "./CustomerDashboardContentLoader.vue?vue&type=style&index=0&id=25dc3b90&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dc3b90"]])

export default __exports__